import { RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { RunnerPhase } from "gitpod-next-api/gitpod/v1/runner_pb";

/**
 * Maps RunnerProvider enum to human-readable display name
 */
export function formatRunnerProvider(provider: RunnerProvider): string {
    switch (provider) {
        case RunnerProvider.AWS_EC2:
            return "Amazon EC2";
        case RunnerProvider.LINUX_HOST:
            return "Linux Host";
        case RunnerProvider.UNSPECIFIED:
            return "Unknown";
        default:
            return "Unknown";
    }
}

/**
 * Maps RunnerPhase to display status with appropriate variant
 */
export function formatRunnerStatus(phase: RunnerPhase): {
    label: string;
    variant: "success" | "warning" | "danger" | "neutral";
} {
    switch (phase) {
        case RunnerPhase.ACTIVE:
            return { label: "Online", variant: "success" };
        case RunnerPhase.INACTIVE:
            return { label: "Offline", variant: "warning" };
        case RunnerPhase.CREATED:
            return { label: "Created", variant: "neutral" };
        case RunnerPhase.DELETING:
            return { label: "Deleting", variant: "danger" };
        case RunnerPhase.UNSPECIFIED:
            return { label: "Unknown", variant: "neutral" };
        default:
            return { label: "Unknown", variant: "neutral" };
    }
}
